import { Component, OnInit } from '@angular/core';
import {NgbModal,NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-get-signed-url',
  templateUrl: './get-signed-url.component.html',
  styleUrls: ['./get-signed-url.component.css']
})
export class GetSignedUrlComponent implements OnInit {

  public bucketData = {};
  public data = {};
  public url;
  public submitted= false;
  constructor(private dataService:DataService, private route: ActivatedRoute,private toastr: ToastrManager) { }

  ngOnInit() {
    this.route.params.subscribe(Data => {
      console.log(Data);
      this.bucketData["bucketName"] = Data.bucketName;
      this.bucketData["Key"] = Data.Key
      this.bucketData["region"]  = localStorage.getItem("region")
      console.log(this.bucketData)
    });
  }
  
  getSignedUrl(){
   return this.dataService.getSignedUrl(this.bucketData).subscribe(res =>{
     console.log(res)
     if(typeof res == 'string'){
       res = JSON.parse(res);
     }

     if(res.Status == 'Success'){
      //  alert(Url.Data)
      this.url= res.Data;
      this.submitted = true;
      this.toastr.successToastr("Your Signed URL generated successfully.","Success!")
     }else {
      //  alert("Error! Please check your details!")
      this.toastr.errorToastr("Please Check Your Details","oops!")
     }
   });
  }
}
